module.exports = __webpack_public_path__ + "img/29_10.1095e7ba.png";